<div class="cookies-notice">
  <div class="map">
    <div class="scroll">
      <div class="table">
        <!-- <app-cookies-notice-bnpes [language]="language"></app-cookies-notice-bnpes> -->
        <app-cookies-notice-bnpes></app-cookies-notice-bnpes>
      </div>
    </div>
  </div>
</div>
